import EsimReservations from "../../components/esim/EsimReservations";
import HeaderPage from "../../components/lines-managements/header/HeaderPage";

const EsimPage = () => {
  return (
    <>
      <div className="relative">
        <HeaderPage
          hasFilter
          filterName="Filtro Rezervimet eSIM"
          filterSelctor="status"
          options={[
            { label: "I konfirmuar", id: "1" },
            { label: "I pa përfunduar", id: "2" },
            { label: "I anuluar", id: "3" },
            { label: "I rimbursuar", id: "4" }
          ]}
        />
      </div>
      <EsimReservations />
    </>
  );
};

export default EsimPage;
